export default "__VITE_ASSET__BHUaiw14__"